import { BLink } from './link';
import { pluginFactory } from '../../utils/plugins';
var LinkPlugin = /*#__PURE__*/pluginFactory({
  components: {
    BLink: BLink
  }
});
export { LinkPlugin, BLink };


// WEBPACK FOOTER //
// ./node_modules/bootstrap-vue/esm/components/link/index.js